import React, { useState } from 'react';
import { Check, Shield, Zap, Sparkles, Heart, Crown, Coffee } from 'lucide-react';
import { createCheckoutSession, PRICE_IDS } from '../services/stripe.js';

export default function Subscription({ user }) {
    const [loading, setLoading] = useState(null); // 'supporter' | 'super_fan' | null

    const handleSubscribe = async (tier) => {
        if (!user) {
            alert("Please sign in to subscribe!");
            return;
        }

        setLoading(tier);
        try {
            const priceId = tier === 'supporter' ? PRICE_IDS.supporter : PRICE_IDS.super_fan;
            const url = await createCheckoutSession(user.uid, priceId);
            window.location.href = url;
        } catch (error) {
            console.error(error);
            alert("Failed to start checkout. Please try again.");
            setLoading(null);
        }
    };

    return React.createElement('div', { className: 'animate-fade-in', style: { maxWidth: '1000px', margin: '0 auto', padding: '20px' } },
        React.createElement('div', { style: { textAlign: 'center', marginBottom: '50px' } },
            React.createElement('h1', { style: { fontSize: '3rem', marginBottom: '15px' } }, "Upgrade Your Spark ✨"),
            React.createElement('p', { style: { fontSize: '1.2rem', color: '#999' } }, "Support the community and unlock exclusive features.")
        ),

        React.createElement('div', { style: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' } },

            // FREE TIER
            React.createElement('div', { className: 'glass-panel', style: { padding: '30px', borderTop: '4px solid #999' } },
                React.createElement('h3', { style: { fontSize: '1.5rem', marginBottom: '10px' } }, "Global"),
                React.createElement('div', { style: { fontSize: '2rem', fontWeight: 'bold', marginBottom: '20px' } }, "Free"),
                React.createElement('ul', { style: { textAlign: 'left', display: 'flex', flexDirection: 'column', gap: '15px', color: '#ccc' } },
                    React.createElement('li', { style: { display: 'flex', gap: '10px' } }, React.createElement(Check, { size: 20 }), "Access to Public Feed"),
                    React.createElement('li', { style: { display: 'flex', gap: '10px' } }, React.createElement(Check, { size: 20 }), "Create & Share Sparks"),
                    React.createElement('li', { style: { display: 'flex', gap: '10px' } }, React.createElement(Check, { size: 20 }), "Basic Profile Stats"),
                    React.createElement('li', { style: { display: 'flex', gap: '10px' } }, React.createElement(Check, { size: 20 }), "Daily Challenges")
                ),
                React.createElement('button', {
                    disabled: true,
                    className: 'btn-ghost',
                    style: { width: '100%', marginTop: '30px', cursor: 'default', opacity: 0.5 }
                }, "Current Plan")
            ),

            // SUPPORTER TIER
            React.createElement('div', { className: 'glass-panel', style: { padding: '30px', borderTop: '4px solid #ec4899', position: 'relative', transform: 'scale(1.02)' } },
                React.createElement('div', { style: { position: 'absolute', top: '-12px', left: '50%', transform: 'translateX(-50%)', background: '#ec4899', color: 'white', padding: '4px 12px', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold' } }, "MOST POPULAR"),
                React.createElement('h3', { style: { fontSize: '1.5rem', marginBottom: '10px', color: '#ec4899', display: 'flex', alignItems: 'center', gap: '10px' } },
                    React.createElement(Coffee, { size: 24 }), "Supporter"
                ),
                React.createElement('div', { style: { fontSize: '2rem', fontWeight: 'bold', marginBottom: '20px' } }, "$5", React.createElement('span', { style: { fontSize: '1rem', color: '#999', fontWeight: 'normal' } }, "/mo")),
                React.createElement('ul', { style: { textAlign: 'left', display: 'flex', flexDirection: 'column', gap: '15px', color: '#eee' } },
                    React.createElement('li', { style: { display: 'flex', gap: '10px' } }, React.createElement(Check, { size: 20, color: '#ec4899' }), "Everything in Global"),
                    React.createElement('li', { style: { display: 'flex', gap: '10px' } }, React.createElement(Check, { size: 20, color: '#ec4899' }), "Pink Name in Chat"),
                    React.createElement('li', { style: { display: 'flex', gap: '10px' } }, React.createElement(Check, { size: 20, color: '#ec4899' }), "Exclusive 'Coffee' Badge ☕"),
                    React.createElement('li', { style: { display: 'flex', gap: '10px' } }, React.createElement(Check, { size: 20, color: '#ec4899' }), "5 Saved History Slots"),
                    React.createElement('li', { style: { display: 'flex', gap: '10px' } }, React.createElement(Check, { size: 20, color: '#ec4899' }), "10 Extra Custom Emotes")
                ),
                React.createElement('button', {
                    onClick: () => handleSubscribe('supporter'),
                    disabled: loading !== null,
                    className: 'btn',
                    style: { width: '100%', marginTop: '30px', background: 'var(--secondary)', border: 'none' }
                }, loading === 'supporter' ? "Loading..." : "Join Supporters")
            ),

            // SUPER FAN TIER
            React.createElement('div', { className: 'glass-panel', style: { padding: '30px', borderTop: '4px solid #8b5cf6', background: 'linear-gradient(to bottom, rgba(139, 92, 246, 0.1), rgba(0,0,0,0))' } },
                React.createElement('h3', { style: { fontSize: '1.5rem', marginBottom: '10px', color: '#8b5cf6', display: 'flex', alignItems: 'center', gap: '10px' } },
                    React.createElement(Crown, { size: 24 }), "Super Fan"
                ),
                React.createElement('div', { style: { fontSize: '2rem', fontWeight: 'bold', marginBottom: '20px' } }, "$10", React.createElement('span', { style: { fontSize: '1rem', color: '#999', fontWeight: 'normal' } }, "/mo")),
                React.createElement('ul', { style: { textAlign: 'left', display: 'flex', flexDirection: 'column', gap: '15px', color: '#eee' } },
                    React.createElement('li', { style: { display: 'flex', gap: '10px' } }, React.createElement(Check, { size: 20, color: '#8b5cf6' }), "Everything in Supporter"),
                    React.createElement('li', { style: { display: 'flex', gap: '10px' } }, React.createElement(Check, { size: 20, color: '#8b5cf6' }), "Purple Name in Chat"),
                    React.createElement('li', { style: { display: 'flex', gap: '10px' } }, React.createElement(Check, { size: 20, color: '#8b5cf6' }), "Exclusive 'Crown' Badge 👑"),
                    React.createElement('li', { style: { display: 'flex', gap: '10px' } }, React.createElement(Check, { size: 20, color: '#8b5cf6' }), "Unlimited History"),
                    React.createElement('li', { style: { display: 'flex', gap: '10px' } }, React.createElement(Check, { size: 20, color: '#8b5cf6' }), "Customize Site Theme")
                ),
                React.createElement('button', {
                    onClick: () => handleSubscribe('super_fan'),
                    disabled: loading !== null,
                    className: 'btn',
                    style: { width: '100%', marginTop: '30px', background: 'var(--primary)', border: 'none' }
                }, loading === 'super_fan' ? "Loading..." : "Become a Super Fan")
            )
        )
    );
}
